import { defineStore } from 'pinia'
import type { IChitStoreState } from './chit.types'
import { ChitState } from '@/models/chit'

export const useChitStore = defineStore('chit', {
  state: () =>
    ({
      chitStateVisuals: [
        {
          state: ChitState.Assigned,
          text: 'Assigned',
          icon: 'mdi-file-document-outline',
          color: 'rgba(var(--v-theme-draft))'
        },
        {
          state: ChitState.Submitted,
          text: 'Submitted',
          icon: 'mdi-file-send-outline',
          color: 'rgba(var(--v-theme-submitted))'
        },
        {
          state: ChitState.Approved,
          text: 'Approved',
          icon: 'mdi-check',
          color: 'rgba(var(--v-theme-approved))'
        }
      ]
    }) as IChitStoreState,

  getters: {
    getChitVisualByState: (state: IChitStoreState) => (chitState: number) => {
      return state.chitStateVisuals.find((stateVisual) => stateVisual.state === chitState)
    }
  }
})
